import { TransactionScheduleFieldsFragment } from '../../graphql/generated';
import { useFinancialEntities } from '../financialEntities';

export const useIsEditingEnabled = (
    ts: TransactionScheduleFieldsFragment
): boolean => {
    const { sourceId, destinationId } = ts;
    const { unfilteredData } = useFinancialEntities();

    if (!unfilteredData) return false;

    const sourceAccount = unfilteredData.financialEntities.find(
        (fe) => fe.id === sourceId
    );
    const destinationAccount = unfilteredData.financialEntities.find(
        (fe) => fe.id === destinationId
    );

    if (!sourceAccount || !destinationAccount) return false;

    return (
        sourceAccount.ownersIncludeMyself &&
        destinationAccount.ownersIncludeMyself
    );
};
